<template>
  <el-dialog :visible.sync="visible"
             title="隐私政策"
             v-if='visible'
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :show-close="false"
             width="40%">

    <div>
      根据【宝马中国评估中心】流程，候选人所获评估报告将由【宝马中国评估中心】与为其发起测评的经销商分享。如果贵店希望授权候选人查看，请选择“同意”，则候选人在首次上岗后即可在【悦学苑APP】“我的->我的发展计划”中查看本人的评估报告。此授权为经销商行为，非【宝马中国评估中心】对候选人的直接授权，请知悉并确认。
    </div>
    <template slot="footer">
      <div v-show="!disabled">
        <el-button type=""
                   class="buttonqx"
                   :disabled="disabled"
                   @click="sendEnabledNo(false)">不同意
        </el-button>
        <el-button type=""
                   class="buttonqy"
                   :disabled="disabled"
                   @click="sendEnabled(true)">同意
        </el-button>
      </div>
      <div v-show="disabled">
        <el-button type=""
                   :disabled="disabled"
                   class="buttonqxy">[10]秒后可以关闭
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script>
  import $ from 'jquery'

  export default {
    data() {
      return {
        visible: false,
        disabled: true,
      }
    },
    methods: {
      init() {
        this.visible = true
        this.$nextTick(() => {
          this.getConfirm(10)
        })
      },
      getConfirm(time) {
        var _this = this
        if (time === 0) {
          this.disabled = false
          $('.buttonqx').html('不同意')
          $('.buttonqy').html('同意')
        } else {
          // 按钮不可用
          this.disabled = true
          $('.buttonqxy').html(this.$t('agreement.confirm', {'handle': time}))
          // $('.buttonqy').html(this.$t('agreement.confirm', { 'handle': time }))
          time--
          setTimeout(function () {
            _this.getConfirm(time)
          }, 1000)
        }
      },
      sendEnabled(val) {
        this.$emit('func', val)
        this.visible = false
      },
      sendEnabledNo(val) {
        this.$emit('funcNO', val)
        this.visible = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .disableClick {
    text-align: center;
  }

  .el-input-number {
    width: 100% !important;
  }

  .el-input__inner {
    text-align: left !important;
  }

  .el-button.el-button--default.buttonqx {
    margin: 0px !important;
    width: 50%;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    background-color: #434343 !important;
    color: #fff;
    border: 0px;
    line-height: 25px;
  }

  .el-button.el-button--default.buttonqy {
    margin: 0px !important;
    width: 50%;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    color: #fff;
    border: 0px;
    line-height: 25px;
  }

  .el-button.el-button--default.buttonqxy {
    margin: 0px !important;
    width: 100%;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    background-color: #999999 !important;
    color: #fff;
    border: 0px;
    line-height: 25px;
  }

  .el-button.is-disabled,
  .el-button.is-disabled:focus,
  .el-button.is-disabled:hover {
    color: #666;
    background-color: #eee;
  }

  .el-button.el-button--default.is-disabled:hover {
    color: #666;
    background-color: #eee !important;
  }

  .el-button.el-button--default.is-disabled {
    color: #666;
    background-color: #eee !important;
  }

  .el-button.el-button--default {
    color: #fff;
    background-color: #5c9df5 !important;
    border-color: #5c9df5;
  }

  .buttomqr {
    margin-left: 0px !important;
    float: left !important;
    width: 100% !important;
    line-height: 23px;
  }

  .el-dialog__body div {
    // margin-top: 16px;
    line-height: 20px;
  }

  .el-dialog__header {
    text-align: center;
    font-size: 18px;
  }
</style>
